import { ReactNode, useContext, useEffect } from "react";
import { ExperimentContext } from "../../../context/experiment-context";
import { GrowthBookProvider } from "@growthbook/growthbook-react";
import {
  GrowthBookClient,
  getGrowthBookCookie,
} from "../../../implementations/growthbook/growthbook-client";
import { AppContext } from "../../../context/app";
import { interop_trackEvent } from "../../../utils/analytics.interop";

interface ExperimentProviderProps {
  client: GrowthBookClient;
  children: ReactNode;
}

function ExperimentProvider({ client, children }: ExperimentProviderProps) {
  const app = useContext(AppContext);
  const user = app.user;

  const trackingCb = (experiment: any, result: any) => {
    interop_trackEvent("Experiment Viewed", {
      userUuid: user.user_uuid,
      anonymousId: getGrowthBookCookie(),
      experimentId: experiment.key,
      variationId: result.key,
    });
  };

  client.instance.setTrackingCallback(trackingCb);

  useEffect(() => {
    client
      .init()
      .then(() => {
        client.setAttributes({
          sessionId: getGrowthBookCookie(),
          userUuid: user.user_uuid,
          company: user.company,
          clientUuid: app.client.uuid ?? app.client.client_uuid, // Note: client_uuid is the old key for PHP pages, uuid is the new key for React pages
          clientId: app.client.id ?? app.client.client_id, // Note: client_uuid is the old key for PHP pages, uuid is the new key for React pages
          role: user.role,
          plan: app.client.planType,
          superuser: user.superuser,
          membershipStatus: user.membershipStatus,
        });
      })
      .catch((err) => console.error("Exp. error:", err));
  }, [
    client,
    app.client.client_id,
    app.client.client_uuid,
    app.client.id,
    app.client.planType,
    app.client.uuid,
    user.company,
    user.membershipStatus,
    user.role,
    user.superuser,
    user.user_uuid,
  ]);

  return (
    <GrowthBookProvider growthbook={client.instance}>
      <ExperimentContext.Provider value={client}>
        {children}
      </ExperimentContext.Provider>
    </GrowthBookProvider>
  );
}

export default ExperimentProvider;
